<template>
  <div class="bg-background-light-300 flex h-screen w-full items-center justify-center">
    <div class="lg:m-auto lg:w-2/5">
      <slot></slot>
    </div>
  </div>
</template>
